import { App } from 'vue';
import BreakPoints from './BreakPoints';

export default function config(app: App): void {
    app.component('BreakPoints', BreakPoints);
}
